import { Injectable } from '@angular/core'
import {
  AvailableCardLimit, CardLimit, CreateLimitRequestDocument, GetInstalledLimitResponse, SendingDataLimit,
  SendingLimitDocument
} from '../_models/card-limit.model'
import { map, shareReplay, take } from 'rxjs/operators'
import { forkJoin, Observable, Observer } from 'rxjs';
import { ConfirmService } from '@core/services/confirm/confirm.service'
import { ApiService } from '@core/services/api/api.service';

@Injectable()

export class CardLimitService {

  constructor(
    private apiService: ApiService,
    private confirmService: ConfirmService
  ) {
  }

  private getAvailableLimits() {
    return this.apiService.get<AvailableCardLimit[]>('rest/personal/limit/availableLimit')
      .pipe(
        take(1)
      );
  }

  private getCurrentLimitsByCard(cardNumber: string) {
    return this.apiService.get<GetInstalledLimitResponse>(`rest/personal/limit/installedLimit?cardNumber=${cardNumber}`)
      .pipe(
        map(res => res.limits ? res.limits.limit : []),
        take(1)
      )
  }

  private createLimitDocument(data: CreateLimitRequestDocument) {
    return this.apiService.post<number, any>('rest/personal/limit/createLimit', data)
      .pipe(take(1))
  }

  private sendLimitDocument(data: SendingLimitDocument) {
    return this.apiService.post<SendingLimitDocument, any>('rest/personal/limit/changeLimit', data)
      .pipe(take(1))
  }

  setLimits(accId: string, data: SendingDataLimit[]): Observable<any> {
    return Observable.create(async (observer: Observer<any>) => {
      try {
        const docId = await this.createLimitDocument({accId, infoForBank: 'Изменение лимитов по карте'}).toPromise()
        if (docId) {
          const confirmed = await this.confirmService.confirmDocument(docId.toString())
            .pipe(
              take(1)
            ).toPromise()
          if (confirmed) {
            const resultData = await this.sendLimitDocument({docId, limitList: data}).toPromise()
            const success = this.handleSetLimitResponse(resultData)
            if (!success) {
              observer.error('Запрос выполнен частисно')
              observer.complete
            }
            observer.next('Лимиты установлены')
            observer.complete()
          }
        }
      } catch (e) {
        observer.error(e);
        observer.complete()
      }
    })
  }

  getLimits(cardNumber: string) {
    return forkJoin([
      this.getAvailableLimits(),
      this.getCurrentLimitsByCard(cardNumber)
    ]).pipe(
      map(([dboLimits, bpcLimits]) => {
        const listLimits: CardLimit[] = [];
        if (dboLimits) {
              dboLimits.forEach(dboLimit => {
                let bpcLimit = bpcLimits.find(bpcLimit => bpcLimit.name === dboLimit.code);
                if (typeof bpcLimit !== 'undefined') {
                  const bpcValue = bpcLimit.value.toString();
                  if (bpcValue.length > 3) {
                    bpcLimit.value = bpcValue.substring(0, bpcValue.length - 2);
                  }
                  listLimits.push(Object.assign(dboLimit, bpcLimit))
                }
              })
        }
        if (!listLimits.length) {
          throw 'Сервис временно не доступен'
        }
        return listLimits;
      })
    )
  }

  private handleSetLimitResponse(response: SendingLimitDocument) {
    let successResult = true;
    response.limitList.forEach(limit => {
      successResult = successResult && limit.result
    })
    return successResult
  }
}
